<script setup>
import {computed} from 'vue'
import {useComponentsStore} from '@/stores/components'
import FormControlCategoryTitle from "@/common/form-control/FormControlCategoryTitle.vue"

const props = defineProps({
    oldValue: Number,
    newValue: Number,
    categoryComponentId: Number
})

const componentsStore = useComponentsStore()

const component = computed(() => {
    return componentsStore.items.find(o => o.id === props.categoryComponentId)
})

const tableName = computed(() => {
    return component.value?.tableName
})
</script>

<template>
    <div class="d-flex align-items-center">
        <FormControlCategoryTitle v-if="oldValue" class="border rounded py-1 px-2 small" :table-name="tableName"
                                  :id="oldValue"/>
        <i v-else>none</i>

        <i class="mx-2 bi-chevron-right"/>

        <FormControlCategoryTitle v-if="newValue" class="border rounded py-1 px-2 small" :table-name="tableName"
                                  :id="newValue"/>
        <i v-else>none</i>
    </div>
</template>